module.exports = __webpack_public_path__ + "static/media/2e-building.b2a45191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2e-building.png
// module id = 132
// module chunks = 0